var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.institute_configs.currency)?_c('button',[_vm._v(" "+_vm._s(_vm.institute_configs.currency)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }